import { AnyAction } from 'redux';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';

import { Search } from '../components';
import {
  SearchConditions,
  SearchState,
  searchDocuments,
  clearSearchMessages,
  clearSearch,
} from '../modules/search';
import {
  DownloadConditions,
  DownloadState,
  downloadDocuments,
  clearDownloadMessages,
} from '../modules/searchTsv';
import {
  getTags,
  TagsState,
  clearGetTagsMessages,
  clearTags,
} from '../modules/tags';
import {
  UpdateState,
  setUpdateCategory,
  setUpdateCategories,
  updateContent,
  clearUpdate,
} from '../modules/update';
import { DeleteState, deleteContent, clearDelete } from '../modules/delete';
import { goSearchPage, goLoginPage } from '../modules/pages';
import { clearUpload } from '../modules/upload';
import { clearUploadForHighlight } from '../modules/uploadForHighlight';
import { clearUploadForRiskJudge } from '../modules/uploadForRiskJudge';
import { clearUploadForSearch } from '../modules/uploadForSearch';
import { clearRiskJudge } from '../modules/riskJudge';
import { clearComparision } from '../modules/comparison';
import { clearComparisionForHighlight } from '../modules/comparisonHighlight';
import { clearComparisionForSearch } from '../modules/comparisonSearch';
import { clearComparisionForHighlightSave } from '../modules/comparisonHighlightSave';

// configureStoreで設定した名前をセット
export function mapStateToProps(state: {
  search: SearchState,
  searchTsv: DownloadState,
  tags: TagsState,
  update: UpdateState,
  deleteMod: DeleteState,
}) {
  const { search, searchState, searchMessages, statusS } = state.search;
  const { searchDownload, downloadMessages, statusT } = state.searchTsv;
  const { tags, tagsMessages, status } = state.tags;
  const { newCategories, updateMessages, statusU } = state.update;
  const { statusD } = state.deleteMod;
  const tagStatus = status;
  const searchStatus = statusS;
  const updateStatus = statusU;
  const tsvStatus = statusT;
  const deleteStatus = statusD;

  return {
    search,
    searchState,
    searchMessages,
    searchDownload,
    downloadMessages,
    tags,
    tagsMessages,
    newCategories,
    updateMessages,
    tagStatus,
    searchStatus,
    updateStatus,
    tsvStatus,
    deleteStatus,
  };
}

export function mapDispatchToProps(dispatch: ThunkDispatch<any, any, AnyAction>) {
  return {
    goSearchPage: () => {
      dispatch(goSearchPage());
    },
    searchDocuments:
      (conditions: SearchConditions) => dispatch(searchDocuments(conditions)),
    clearSearchMessages: () => dispatch(clearSearchMessages()),
    downloadDocuments:
      (conditions: DownloadConditions) => dispatch(downloadDocuments(conditions)),
    clearDownloadMessages: () => dispatch(clearDownloadMessages()),
    getTags: () => dispatch(getTags()),
    clearGetTagsMessages: () => dispatch(clearGetTagsMessages()),
    setUpdateCategory:
      (index: number, newTagId: number) => dispatch(setUpdateCategory(index, newTagId)),
    setUpdateCategories:
      (newCategories: number[]) => dispatch(setUpdateCategories(newCategories)),
    updateContent:
      (index: number, id: string, newTagId: number, status: number) =>
        dispatch(updateContent(index, id, newTagId, status)),
    deleteContent: (index: number, id: string) => dispatch(deleteContent(index, id)),
    goLoginPage: () => {
      dispatch(goLoginPage());
      dispatch(clearUpload());
      dispatch(clearUploadForHighlight());
      dispatch(clearUploadForRiskJudge());
      dispatch(clearUploadForSearch());
      dispatch(clearRiskJudge());
      dispatch(clearComparision());
      dispatch(clearComparisionForHighlight());
      dispatch(clearComparisionForSearch());
      dispatch(clearComparisionForHighlightSave());
      dispatch(clearSearch());
      dispatch(clearTags());
      dispatch(clearUpdate());
      dispatch(clearDelete());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Search);



// WEBPACK FOOTER //
// ./src/containers/Search.tsx